import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { Fragment, useState } from "react";

const VerticalTab = ({ tabData, title, description }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const onItemClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <>
      <h2 className="text-4xl md:text-3xl lg:text-6xl text-black mb-0 font-medium w-full pb-7 md:w-3/5 md:pb-4 lg:w-3/4 lg:pb-7 leading-tight md:leading-snug lg:leading-tight">
        <span>{title}</span>
      </h2>
      <p className="text-base text-black mb-0 font-normal text-justify w-full lg:w-3/4 pb-10 md:pb-10 lg:pb-24">
        <span dangerouslySetInnerHTML={{ __html: description }}></span>
      </p>
      <div className="block md:hidden">
        <div>
          {tabData.leftTabData.map((value, index) => (
            <div
              key={value.id}
              className="cursor-pointer border border-solid mb-6 rounded-2xl"
            >
              <div
                className="text-left py-7 px-4 md:mx-4 flex justify-between items-center"
                onClick={() => onItemClick(index)}
              >
                <h4
                  className={`font-normal text-lg md:text-xl flex items-center  w-11/12 ${
                    index === activeIndex
                      ? "text-primary-yellow"
                      : "text-black/60"
                  }`}
                >
                  <span>{value.title}</span>
                </h4>
                <span className="flex">
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`text-black/60 ${
                      index === activeIndex ? "rotate-180" : ""
                    }`}
                    width={14}
                    height={14}
                  />
                </span>
              </div>
              <div
                className={`text-base text-justify px-4 pb-4 text-black ${
                  index === activeIndex ? "block " : "hidden"
                }`}
              >
                <div>
                  {tabData.tabRightCard.map(
                    (itm) =>
                      itm.id === value.id && (
                        <Fragment key={itm.id}>
                          <div className="flex">
                            {itm.cardImg.map((value_) => (
                              <div key={value_.id} className="mr-6">
                                <Image
                                  alt={value_.alt}
                                  height={48}
                                  objectFit="contain"
                                  src={value_.img}
                                  width={48}
                                />
                              </div>
                            ))}
                          </div>
                          <p className="text-sm font-medium mt-7 text-justify">
                            <span>{itm.description}</span>
                          </p>
                        </Fragment>
                      )
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="hidden md:block">
        <div className="md:flex">
          <div className="w-1/2 px-3">
            {tabData.leftTabData.map((value, index) => (
              <div
                key={value.id}
                className={`font-medium border border-solid border-gray-300 md:text-lg lg:text-2xl md:py-6 md:px-7 lg:py-7 lg:px-9 md:rounded-lg lg:rounded-2xl md:mb-7 lg:mb-10 cursor-pointer last:mb-0 ${
                  index === activeTab ? "text-primary-yellow" : ""
                }`}
                role="tab"
                tabIndex={index === activeTab ? 0 : -1}
                onClick={() => handleTabClick(index)}
              >
                <span>{value.title}</span>
              </div>
            ))}
          </div>
          <div className="w-1/2 px-3">
            {tabData.tabRightCard.map((value, index) => (
              <div
                key={value.id}
                className={`${index === activeTab ? "block" : "hidden"}`}
              >
                <div className="max-w-[629px] md:rounded-lg lg:rounded-2xl md:px-7 lg:px-10 pt-10 md:pb-20 lg:pb-28 mr-0 ml-auto border border-solid border-gray-300">
                  <div className="grid grid-cols-4 md:gap-x-7 lg:gap-x-12 ">
                    {value.cardImg.map((item) => (
                      <div key={item.id} className="flex">
                        <Image
                          alt={item.alt}
                          height={78}
                          objectFit="contain"
                          src={item.img}
                          title={item.alt}
                          width={78}
                        />
                      </div>
                    ))}
                  </div>
                  <h3 className="font-normal md:text-xl text-black lg:text-4xl mt-10 mb-7">
                    <span>{value.title}</span>
                  </h3>
                  <p className="xl:text-base md:text-sm font-normal text-black lg:mb-4 text-justify">
                    <span>{value.description}</span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default VerticalTab;
